<div auto="add-activity-title" class="sidebar-header">{{headerContent}}</div>

<form class="standard-form" (ngSubmit)="onSubmit()" [formGroup]="activityForm">
  <label class="standard-label" for="activityDescription">Activity Description</label>
  <textarea auto="activity-description" pInputTextarea class="text-area short-text-area standard-input"
            id="activityDescription"
            name="activity description" placeholder="Enter activity description here"
            [maxlength]="MAX_DESCRIPTION_LENGTH" formControlName="description">
  </textarea>
  <div class="remaining-msg">Remaining: {{MAX_DESCRIPTION_LENGTH - descriptionCharCount}}</div>
  <app-error-msg [control]="activityForm.controls['description']"
                 [show]="activityForm.controls['description'].touched && activityForm.controls['description'].invalid
                  && activityForm.controls['description'].dirty">
  </app-error-msg>

  <label class="standard-label">Select a Tag</label>
  <p-dropdown auto="activity-tag" [options]="adEdSelectItems" formControlName="tag"
              styleClass="app-form-dropdown wide-dropdown"
              placeholder="Select a Tag" [autoWidth]="false"></p-dropdown>
  <app-error-msg [control]="activityForm.controls['tag']"
                 [show]="activityForm.controls['tag'].touched && activityForm.controls['tag'].invalid
                 && activityForm.controls['tag'].dirty">
  </app-error-msg>

  <label class="standard-label" for="priorityTitle">Person Responsible</label>
  <div class="input-wrap">
    <input auto="person-responsible-field" class="standard-input" type="text" id="priorityTitle"
           placeholder="Enter person responsible here"
           formControlName="personResponsible" name="person-responsible" [maxlength]="MAX_PERSON_RESPONSIBLE_LENGTH">
    <div class="remaining-msg">Remaining: {{MAX_PERSON_RESPONSIBLE_LENGTH - responsibleCharCount}}</div>
  </div>

  <label class="standard-label">Financial Resource</label>
  <div class="financial-labels">
    <label class="funding-label" for="requiredFinances">Funding Required</label>
    <label class="source-label" for="fundingSource">Source of Funding</label>
  </div>
  <div class="financial-inputs">
    <div class="dollar-input-container">
      <span class="dollar-label">$</span>
      <input auto="financial-resources-field"
             [appInputNumber]="activityForm.get('requiredFinances')"
             class="standard-input short-input dollar-input"
             id="requiredFinances"
             placeholder="0.00"
             type="text"
             [max]="MAX_FINANCIAL_RESOURCE_DOLLARS"
             name="required-finances"
             (input)="enforceFinResourceMax($event)"
             formControlName="requiredFinances">
    </div>
    <input auto="financial-resource-source-field"
           class="standard-input source-funding-field"
           type="text"
           id="fundingSource"
           placeholder="Enter funding source here"
           name="funding-source"
           maxlength="120"
           formControlName="sourceOfFunding">
    <app-error-msg [control]="activityForm.controls['requiredFinances']"
                   [show]="activityForm.controls['requiredFinances'].touched &&
                           activityForm.controls['requiredFinances'].invalid &&
                           activityForm.controls['requiredFinances'].dirty">
    </app-error-msg>
  </div>
  <label class="standard-label" for="otherResources">Other Resources</label>
  <div class="input-wrap">
     <textarea auto="other-resources-field" pInputTextarea class="text-area short-text-area standard-input"
              id="otherResources" name="other-resources"
              [maxlength]="MAX_OTHER_RESOURCES_LENGTH" placeholder="Enter other resources here"
              formControlName="otherResources">
    </textarea>
    <div class="remaining-msg">Remaining: {{MAX_OTHER_RESOURCES_LENGTH - otherResourcesCharCount}}</div>
  </div>

  <label class="standard-label">Launch Date</label>
  <div class="input-wrap launch-date">
    <p-calendar auto="launch-date-btn" styleClass="strategies-calendar" inputStyleClass="standard-input"
                formControlName="launchDate"
                placeholder="Select launch date" [showIcon]="true">
    </p-calendar>
  </div>

  <label class="standard-label" for="measure">Activity Measure(s)</label>
  <div class="input-wrap">
    <textarea auto="activity-measures-field" pInputTextarea class="text-area short-text-area standard-input"
              id="measure" name="measure"
              [maxlength]="MAX_MEASURE_LENGTH" placeholder="Enter activity measure here" formControlName="measure">
    </textarea>
    <div class="remaining-msg">Remaining: {{MAX_MEASURE_LENGTH - measureLength}}</div>
  </div>

  <label class="standard-label">Create Target Cycle</label>
  <div class="input-wrap target-cycle-flex">
    <div>
      <p-calendar styleClass="strategies-calendar activity-calendar" inputStyleClass="standard-input"
                  [formControl]="targetDate" placeholder="Select target date" [showIcon]="true">
      </p-calendar>
      <app-error-msg [control]="targetDate" [show]="targetDate.touched && targetDate.invalid && targetDate.dirty">
      </app-error-msg>
      <app-error-msg [control]="outcome" [show]="outcome.touched && outcome.invalid && outcome.dirty">
      </app-error-msg>
    </div>
    <div>
      <input auto="benchmark-field" class="standard-input" type="text" [formControl]="outcome"
             placeholder="Enter benchmark here"
       [maxlength]="MAX_OUTCOME_LENGTH" name="other-resources">
      <div class="remaining-msg">Remaining: {{MAX_OUTCOME_LENGTH - outcomeLength}}</div>
    </div>
    <div>
      <button auto="add-benchmark-btn" class="btn btn-primary" type="button" [disabled]="isAddTargetCycleDisabled()"
              (click)="onAddTarget(targetDate.value, outcome.value)">Add New</button>
    </div>
  </div>
  <p-table auto="benchmark-table" [value]="selectedActivityTargets" styleClass="activity-table">
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2" class="ui-table-empty-message">
          Add a target cycle
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th class="first-column">Target Date</th>
        <th>Benchmark(s)</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-activityTarget let-index="rowIndex">
      <tr>
        <td class="first-column">
          <div>{{activityTarget.targetDate | date:'MM/dd/yyyy'}}</div>
        </td>
        <td>
          <div class="flex-right-left">
            <div class="hard-break-text">{{activityTarget.expectedOutcome}}</div>
            <i auto="delete-benchmark-flyout-btn" class="fa fa-trash red-icon pointer"
               (click)="onDeleteTargetDate(index)">
            </i>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="button-row">
    <button auto="add-activities-cancel-btn" class="btn btn-alt left-btn" type="button"
            (click)="cancel.emit()">Cancel</button>
  <button auto="add-activities-save-btn" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
</form>
